'use strict';

const Mn = require('backbone.marionette');
const ItemView = require('communication/ui/view/task/item');

module.exports = Mn.CollectionView.extend({
    inCommentTask: false,
    childView: ItemView,
    childViewOptions: function() {
        return {
            context: this.getOption('context'),
            inCommentTask: this.getOption('inCommentTask'),
            AdditionalView: this.getOption('AdditionalView'),
            PrimaryContextView: this.getOption('PrimaryContextView')
        }
    },
    childViewTriggers: {
        'reply:task': 'reply'
    },
    tagName: 'ul',
    className: 'list',
    collectionEvents: {
        'change:deleted': 'render'
    },

    filter: function(child, index) {
        return !child.isDeleted();
    }
});



// WEBPACK FOOTER //
// ./communication/ui/view/task/list-in-comment.js